import { format, formatDistanceToNow, isPast, parseISO } from 'date-fns';

/**
 * Converts a server datetime string to a local Date.
 * Server sends UTC with Z suffix (e.g. "2026-03-12T08:50:00.000000Z").
 * If Z is missing (legacy), we force UTC interpretation by appending it.
 */
const toLocal = d => {
  if (!d) return null;
  if (d instanceof Date) return d;
  let str = String(d);
  // If no timezone indicator, treat as UTC by appending Z
  if (!str.endsWith('Z') && !str.includes('+') && !/[0-9][+-][0-9]{2}:[0-9]{2}$/.test(str)) {
    str = str + 'Z';
  }
  return parseISO(str);
};

export const formatDate     = d => { const l = toLocal(d); return l ? format(l, 'dd MMM yyyy') : '—'; };
export const formatDateTime = d => { const l = toLocal(d); return l ? format(l, 'dd MMM yyyy, HH:mm') : '—'; };
export const timeAgo        = d => { const l = toLocal(d); return l ? formatDistanceToNow(l, { addSuffix: true }) : '—'; };
export const isOverdue      = d => { const l = toLocal(d); return l ? isPast(l) : false; };
export const getInitials    = name => name ? name.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase() : '?';
